module.exports = "module.exports = {\n  context: `${__dirname}/app`,\n  entry: './entry',\n  output: {\n    path: `${__dirname}/dist`,\n    filename: 'bundle.js',\n  },\n  module: {\n    loaders: [\n      {\n        test: /\\.(pug|js|jsx)$/,\n        exclude: /node_modules/,\n        loaders: ['babel?presets[]=es2015&presets[]=react', 'pug-as-jsx'],\n      },\n    ],\n  },\n};\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/screens/Home/sample.webpack.txt
// module id = 901
// module chunks = 0